"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6595,4678],{

/***/ 34678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44012);




var InStockProducts = function(param) {
    var children = param.children, qty = param.qty, stockID = param.stockID, stockValue = param.stockValue;
    var outOfStock = Boolean(+(0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.catalog_products_homepage_out_of_stock_items) === null || ref === void 0 ? void 0 : ref.value;
    }));
    var value = stockID && stockValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "search__fm_dr_Message",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: stockID,
            defaultMessage: stockValue
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !outOfStock && qty === 0 ? value : children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InStockProducts);


/***/ }),

/***/ 26595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26628);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _shared_InStockProducts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34678);
/* harmony import */ var _shop_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97550);
/* harmony import */ var _shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shop_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var ProductCard = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6603)]).then(__webpack_require__.bind(__webpack_require__, 76603));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76603)
            ];
        }
    }
});
function useSetOption(option, filter, dispatch) {
    var callback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(filter, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        dispatch({
            type: "SET_OPTION_VALUE",
            option: option,
            value: callback(data)
        });
    }, [
        option,
        callback,
        dispatch
    ]);
}
function ProductsView(props) {
    var ref;
    var length = props.length, locale = props.locale, isLoading = props.isLoading, productsList = props.productsList, options = props.options, filters = props.filters, dispatch = props.dispatch, propsLayout = props.layout, grid = props.grid, offcanvas = props.offcanvas, forPage = props.forPage, dbName = props.dbName;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(propsLayout), layout = ref1[0], setLayout = ref1[1];
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    var handlePageChange = useSetOption("page", parseFloat, dispatch);
    var handleSortChange = useSetOption("sort", function(event) {
        return event.target.value;
    }, dispatch);
    var handleLimitChange = useSetOption("limit", function(event) {
        return parseFloat(event.target.value);
    }, dispatch);
    var handleResetFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        dispatch({
            type: "RESET_FILTERS"
        });
    }, [
        dispatch
    ]);
    var filtersCount = (ref = Object.keys(filters).map(function(x) {
        return filters[x];
    })) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x;
    }).length;
    var schemaCategoryPage = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "Products in Category",
        "offers": []
    };
    var inventoryClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-list__item"]), forPage === "search" && (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["found-product-card"]));
    var productsListItems = productsList["data"].map(function(product, index) {
        var ref;
        schemaCategoryPage.offers.push({
            "@type": "ListItem",
            "item": {
                "id": product.url_key,
                "name": product === null || product === void 0 ? void 0 : product.name,
                "description": product.description
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_InStockProducts__WEBPACK_IMPORTED_MODULE_6__["default"], {
                qty: (ref = product === null || product === void 0 ? void 0 : product.product_inventories[0]) === null || ref === void 0 ? void 0 : ref.qty,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: inventoryClass,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCard, {
                        product: product,
                        customer: customer,
                        dbName: dbName
                    })
                })
            })
        }, index);
    });
    var rootClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view"]), isLoading && (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view--loading"]));
    var viewOptionsClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["view-options"]), offcanvas === "always" && (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["view-options--offcanvas--always"]), offcanvas === "mobile" && (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["view-options--offcanvas--mobile"]));
    var content;
    if (productsList.emptyCategory) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__empty"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__empty-title"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        id: "no_products_yet",
                        defaultMessage: "There are no products yet!"
                    }),
                    " "
                ]
            })
        });
    } else if ((productsListItems === null || productsListItems === void 0 ? void 0 : productsListItems.length) > 0) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-list"]),
            "data-layout": layout !== "list" ? grid : layout,
            "data-with-features": layout === "grid-with-features" ? "true" : "false",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-list__body"]),
                children: productsListItems
            })
        });
    } else {
        var ref2;
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__empty"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__empty-title"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "sorry_nothing_found_for",
                            defaultMessage: "No matching items"
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__empty-subtitle"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        id: "try_reset_filters",
                        defaultMessage: "Try to reset filters"
                    })
                }),
                !(productsList === null || productsList === void 0 ? void 0 : (ref2 = productsList.data) === null || ref2 === void 0 ? void 0 : ref2.length) && !Object.keys(filters).length ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "btn btn-orange btn-sm",
                    onClick: handleResetFilters,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        id: "reset",
                        defaultMessage: "Reset"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schemaCategoryPage)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: rootClasses,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["products-view__loader"])
                    }),
                    content
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (ProductsView);


/***/ })

}]);